import { PRESCREENING } from '@/constants';

const prescreening = {
  [PRESCREENING.APPROVAL_KEY.APPROVED]: 'Approved',
  [PRESCREENING.APPROVAL_KEY.COMPLETED]: 'Completed',
  [PRESCREENING.APPROVAL_KEY.REJECTED]: 'Rejected',
  [PRESCREENING.APPROVAL_KEY.TODO]: 'In review',
  [PRESCREENING.APPROVAL_KEY.WALLET_FAILED]: 'Wallet failed',
  cddForm: 'CDD Form',
  dilisense: 'Dilisense',
  dilisenseSlogan: 'Free sanction checks and PEP screenings',
  dilisenseSloganDescription:
    'Perform your sanction checks and PEP screenings by accessing a myriad of official government sources from around the globe',
  dilisenseUpload: 'Upload Dilisense pdf',
  enabledWallets: 'Enabled wallets',
  facecheck: 'Facecheck',
  facecheckVerifyProvidedVideo:
    'Closely verify the video showing clearly user face and he/she pronounce these three numbers',
  facecheckVerifyUserInDocumentSameInVideo:
    'Closely verify the person in the document is the same person shown in the video above',
  kyc: 'KYC',
  kycStep1: 'Step 1: Check customer Due Diligence form',
  kycStep2: 'Step 2: Verify all provided documents',
  kycStep3: 'Step 3: Verify the live selfie so we know the user is real',
  kycStep4: 'Step 4: Screen for PeP, Sanctions Crime and Adverse media',
  kycVerifyProvidedDocument: 'Closely verify the provided document',
  legalRepAndUboDifferent: 'They are different',
  legalRepAndUboSame: 'Legal Representative and UBO are the same',
  personalData: 'Declared personal data',
  prescreening: 'Prescreening',
};

export default prescreening;
